import { useSyncExternalStore } from "react";

/**
 * Subscribes to a CSS media query. Matches `window.matchMedia` behaviour (same as `@media` in CSS).
 */
export default function useMediaQuery(query: string): boolean {
  return useSyncExternalStore(
    (onStoreChange) => {
      const mq = window.matchMedia(query);
      mq.addEventListener("change", onStoreChange);
      return () => mq.removeEventListener("change", onStoreChange);
    },
    () => window.matchMedia(query).matches,
  );
}
